export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    reportOperationLog: function reportOperationLog() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/operation/log/report",
        method: "post",
        data: data
      });
    },
    getOperationLogList: function getOperationLogList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/operation/log/list",
        method: "post",
        data: data
      });
    }
  };
});